(() => {
  if (window.magnaProductPageLoaded) return;
  window.magnaProductPageLoaded = true;
  const getForm = picker => picker.closest('[data-product-form]');
  const getSelector = picker => getForm(picker)?.querySelectorAll('.single-option-selector')[Number(picker.dataset.optionIndex)];
  function sync(picker) {
    const form = getForm(picker);
    const selector = getSelector(picker);
    if (!selector) return false;
    let variants = [];
    try { variants = JSON.parse(form.dataset.product).variants; } catch (_) { return false; }
    const selectors = Array.from(form.querySelectorAll('.single-option-selector'));
    const index = Number(picker.dataset.optionIndex);
    picker.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = radio.value === selector.value;
      const available = variants.some(variant => variant.available && variant.options.every((value, i) => value === (i === index ? radio.value : selectors[i]?.value)));
      radio.disabled = !available;
      const note = radio.nextElementSibling?.querySelector('[data-mc-unavailable]');
      if (note) note.hidden = available;
    });
    const wrapper = selectors.length === 1 ? selector.closest('.select') : selector.closest('.selector-wrapper');
    if (wrapper) wrapper.classList.add('mc-native-size-hidden');
    const swatch = form.querySelector('.swatch[data-option-index="' + index + '"]');
    if (swatch) swatch.classList.add('mc-native-size-hidden');
    const selectedLabel = picker.querySelector('[data-mc-selected-colour]');
    if (selectedLabel) selectedLabel.textContent = selector.value;
    picker.hidden = false;
    return true;
  }
  function choose(radio) {
    const picker = radio?.closest('[data-mc-sizes], [data-mc-colours]');
    const selector = picker && getSelector(picker);
    if (!selector || radio.disabled) return;
    selector.value = radio.value;
    selector.dispatchEvent(new Event('change', { bubbles: true }));
    sync(picker);
  }
  function setup(root) {
    root.querySelectorAll('.mc-product-shell .description .tabs').forEach(tabs => {
      const group = document.createElement('div');
      group.className = 'mc-information';
      Array.from(tabs.children).forEach(tab => {
        const label = tab.querySelector('.tab-label');
        const content = tab.querySelector('.tab-content');
        if (!label || !content) return;
        const policyTemplate = tabs.closest('.description')?.querySelector('[data-mc-policy-template]');
        if (policyTemplate && label.textContent.trim() === 'Shipping Times & Returns') {
          content.replaceChildren(policyTemplate.content.cloneNode(true));
        }
        const sustainabilityTemplate = tabs.closest('.description')?.querySelector('[data-mc-sustainability-template]');
        if (sustainabilityTemplate && label.textContent.trim() === 'Sustainable & High Quality') {
          content.replaceChildren(sustainabilityTemplate.content.cloneNode(true));
        }
        const details = document.createElement('section');
        details.className = 'mc-information__item';
        const summary = document.createElement('h2');
        summary.textContent = label.textContent.trim();
        content.className = 'mc-information__content';
        details.append(summary, content);
        group.append(details);
      });
      if (!group.children.length) return;
      const layout = tabs.closest('.mc-product-shell')?.querySelector('.product_section');
      if (layout) layout.append(group);
      else tabs.after(group);
      tabs.remove();
    });
    root.querySelectorAll('[data-mc-sizes], [data-mc-colours]').forEach(picker => {
      if (sync(picker)) return;
      const shell = getForm(picker);
      const observer = new MutationObserver(() => {
        if (!picker.isConnected || sync(picker)) observer.disconnect();
      });
      observer.observe(shell, { childList: true, subtree: true });
    });
  }
  document.addEventListener('click', event => {
    const label = event.target.closest('.mc-size-card, .mc-colour-card');
    if (label) {
      const radio = document.getElementById(label.htmlFor);
      event.preventDefault();
      choose(radio);
      radio?.focus({ preventScroll: true });
      return;
    }
    const link = event.target.closest('[data-mc-compare]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.querySelector('h2')?.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mc-sizes] input[type="radio"], [data-mc-colours] input[type="radio"]')) choose(event.target);
    if (event.target.matches('[data-product-form] .single-option-selector')) {
      event.target.closest('[data-product-form]')?.querySelectorAll('[data-mc-sizes], [data-mc-colours]').forEach(picker => queueMicrotask(() => sync(picker)));
    }
  }, true);
  window.addEventListener('popstate', () => setTimeout(() => setup(document), 0));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
